import React from 'react';
import { ShieldCheck, HardDrive } from 'lucide-react';
import { DOCUMENT_DEFAULTS } from '../../config/document.config';

interface StatusBarProps {
  documentTitle?: string;
  wordCount?: number;
  pageCount?: number;
}

export const StatusBar: React.FC<StatusBarProps> = ({
  wordCount = 0,
  pageCount = 1,
}) => {
  return (
    <footer className="app-statusbar" role="status" aria-label="Editor Status">
      <div className="status-left">
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span className="status-indicator" />
          <span>Local Engine Active</span>
        </span>

        <span style={{ color: 'var(--border-strong)' }}>|</span>

        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <ShieldCheck size={13} color="var(--color-success)" />
          <span>100% Client-Side Privacy</span>
        </span>
      </div>

      <div className="status-right">
        <span>Format: <strong>{DOCUMENT_DEFAULTS.paperSize}</strong></span>
        <span>Pages: <strong>{pageCount}</strong></span>
        <span>Words: <strong>{wordCount}</strong></span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <HardDrive size={13} />
          <span>IndexedDB Cache</span>
        </span>
      </div>
    </footer>
  );
};
